module.exports = __webpack_public_path__ + "static/media/mrlgd.81a7dc37.svg";